import { mergeToNewObject } from '../../../util/object.helpers'

import { GAME_ACTION } from '../../../constants/actions'
import { SCRATCH_GAME_STATUS } from '../../../constants/game'

export const gameProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GAME_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case GAME_ACTION.PLAY_GAME:
      return mergeToNewObject(state, {
        scratchStatus: SCRATCH_GAME_STATUS.SCRATCHING,
        result: null,
        error: {}
      })

    case GAME_ACTION.PLAY_SUCCESS:
      const { result } = payload
      return mergeToNewObject(state, {
        result,
        scratchStatus: SCRATCH_GAME_STATUS.REVEAL
      })

    case GAME_ACTION.PLAY_FAILED:
      return mergeToNewObject(state, {
        scratchStatus: SCRATCH_GAME_STATUS.INIT
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  scratchStatus: SCRATCH_GAME_STATUS.INIT,
  result: null,
  error: {}
}

export const GAME_PROFILE_DISPATCH = {
  ERROR: 'error',
  SCRATCH_STATUS: 'scratchStatus'
}
